module.exports = __webpack_public_path__ + "img/dslv_logo.0a1ff08e.svg";